import { ref } from "vue";
const googleObj = ref();

const setGoogleObj = (g: any) => googleObj.value = g;

export {setGoogleObj, googleObj}